<template>
	<div id="viewLandRecordViewBox">
		<div class="w-full flex">
			<div class="w-4/5">
				<mapbox
					id="map"
					:accessToken="accessToken"
					:map-options="mapOptions"
					@map-load="mapLoaded"
					@map-init="mapInitialized"
					>
				</mapbox>
			</div>

			<div class="w-1/5">
				<div class="certificate_info_box">
					<div class="info_producer_name info_box_infoLine">
						{{ certificateData.ProducerName }}
					</div>

					<table class="w-full">
						<tr>
							<td class="icon_header">
							<font-awesome-icon icon="map-marked-alt"> </font-awesome-icon>
							</td>

							<td class="info_body">
								<div class="calculated-area flex">
									<span>{{ certificateData.LandMarkedGEOJsonArea }}</span>
								</div>
							</td>
						</tr>

						<tr>
							<td class="icon_header">
							<font-awesome-icon icon="user-shield"> </font-awesome-icon>
							</td>

							<td class="info_body">
								{{ certificateData.CertifierName }}
							</td>
						</tr>

						<tr>
							<td class="icon_header">
								<font-awesome-icon icon="leaf"> </font-awesome-icon>
							</td>

							<td class="info_body">
								{{ certificateData.CropType }}
							</td>
						</tr>

						<tr>
							<td class="icon_header">
								<font-awesome-layers class="fg-lg">
									<font-awesome-icon icon="calendar-alt" style="color:#000"> </font-awesome-icon>

									<font-awesome-icon
										icon="check"
										transform="shrink-6 down-4 right-4"
										style="color:#3FDE18"
										>
									</font-awesome-icon>
								</font-awesome-layers>
							</td>

							<td class="info_body">
								Issued on
								{{ certificateData.DateIssued }}
							</td>
						</tr>
						<tr>
							<td class="icon_header">
								<font-awesome-layers class="fg-lg">
									<font-awesome-icon icon="calendar-alt" style="color:#000"> </font-awesome-icon>

									<font-awesome-icon
										icon="check"
										transform="shrink-6 down-4 right-4"
										style="color:#3FDE18"
										>
									</font-awesome-icon>
								</font-awesome-layers>
							</td>

							<td class="info_body">
								Date created
								{{ certificateData.DateCreated }}
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Mapbox from "mapbox-gl-vue";
import TurfArea from "@turf/area";

import { ConvertFromM2To } from "../../utils/areaConverter.js";
import { GEO_JSON_DRAW_OBJ } from "../../utils/consts.js";
import polylabel from "@mapbox/polylabel";
import asyncRequest from "./../../utils/asyncRequest.js";

export default {
	name: "ViewCertificateView",
	created() {
		var certID = this.$route.params.id;
		if (!parseInt(certID)) {
			alert("The certificate you want to view is not specified. Please check your URL.");
		}
		this.getCertificateByID(certID);
	},
	data() {
		return {
			areaOptions: [
				{ value: "acre", label: "Acres" },
				{ value: "squarekilometer", label: "Square Kilometres" },
				{ value: "squaremetre", label: "Square Metres" },
				{ value: "squaremile", label: "Square Miles" },
				{ value: "squareyard", label: "Square Yard" },
				{ value: "squarefoot", label: "Square Feet" },
				{ value: "squareinch", label: "Square Inchs" }
			],
			certificateData: {
				CertificateID: "C91024091-C-5-84-90-Ax00344865C",
				ProducerID: "Farm Soy Foods, LLC",
				CropType: "Soy",
				weightInKG: "50000",
				CertifierName: "[BAC] BioAgriCert (NOP Code : 869)",
				DateIssued: "2019-04-19",
				ExpiryDate: "2020-04-19",
				CertifierComments: "First inspection.",
				AreaGPSCoordinates: [
					[-9.139408866528186, 38.71293247887786],
					[-9.13665351678145, 38.71355841671823],
					[-9.135049135914102, 38.7101020828315],
					[-9.138083508417395, 38.70944889859831],
					[-9.139508866528186, 38.71293247887786]
				]
			},
			//This guy has to be inited after the map has inited in the @map
			//After the @map-init event has happened
			initedMap: {},
			areaUnit: "Acre",
			areaInM2: "",
			areaWithUnits: "",
			accessToken:
			"pk.eyJ1IjoibWFsaWtmb3V6ZSIsImEiOiJjanF6ZHU2ZHowZDF1NDNsazl6dWF2OXoxIn0.7ZmKrMF5juUPgm2QS6RpsQ",
			mapOptions: {
				style: "mapbox://styles/malikfouze/cjqzfa3r72dku2sljvm9d0sks",
				center: [-106.657807, 52.136847]
			}
		};
	},
	methods: {
		//Assumption here is we always get weightIn as a KG value
		getWeight(weightIn) {
			return weightIn + " Tons";
		},
		dateTimeFormatter(dataIn) {
			return this.$dateFns.format(new Date(dataIn), "Do-MMMM-YYYY", {
				locale: this.$dateFns.locale
			});
		},
		onSelectedAreaUnitChange(valueIn) {
			this.calculateWithUnits(this.areaInM2, valueIn);
		},
		calculateWithUnits(valInM2, unit) {
			var convertedData = ConvertFromM2To(unit, valInM2);

			//If this func returns nothing
			if (convertedData == 0) {
				this.areaWithUnits = "";
				return;
			}

			this.areaWithUnits = convertedData.areaInConvertedUnit;
		},
		getCertificateByID(certIdIn) {
			asyncRequest.ServerAPI({
				method: "GET",
				api: this.$store.state.urls.GET_CERTIFICATE_BY_ID + certIdIn,
				onSuccessCallback: dataIn => {
					this.reorganizeCertificateDate(dataIn);
				},
				postData: null,
				flags: asyncRequest.M_FAIL,
				customSuccessMessage: "",
				customErrorMessage: "",
				beforeAfterCallback: false
			});
		},
		reorganizeCertificateDate(dataIn) {
			if (!dataIn.Data) {
				this.certificateData = {};
				return;
			}
			//becuase huehueheue thats why :p
			dataIn = dataIn.Data;

			this.certificateData.ProducerName = dataIn.IssuedToOperationName;
			this.certificateData.CropType = dataIn.ProductName;
			this.certificateData.CertifierName = dataIn.CertifierName;
			this.certificateData.DateIssued = this.dateTimeFormatter(dataIn.IssuedOn);
			this.certificateData.DateCreated = this.dateTimeFormatter(dataIn.RecordCreatedOn);
			this.certificateData.LandMarkedGEOJsonArea = dataIn.LandMarkedGEOJsonArea;

			//If we have just one poly to draw, just draw it, otherise draw each poly as a layer and then we need to give
			//each poly a unique name , hence the rand

			//Turn the coordinate data we got from the server in to a new js obj
			//So that we can access its props for stuff
			var gjson = JSON.parse(dataIn.LandMarkedGEOJson);

			//The geoObj is the main obj we are gonna pass around.
			var geoObj = JSON.parse(JSON.stringify(GEO_JSON_DRAW_OBJ)); 

			if (gjson.type == "MultiPolygon" && gjson.coordinates.length>1) {
				for (let i=0;i<gjson.coordinates.length;i++) {
					geoObj.id = "makredPolygons" + Math.random().toString().substring(2, 8)
					geoObj.source.data.geometry.coordinates = gjson.coordinates[i];
					this.initedMap.addLayer(geoObj);
				}
			}else{
				geoObj.id = "makredPolygons" + Math.random().toString().substring(2, 8)
				geoObj.source.data.geometry.coordinates = gjson.coordinates;
				this.initedMap.addLayer(geoObj);
			}

			this.initedMap.flyTo({
				center: polylabel(geoObj.source.data.geometry.coordinates),
				zoom: 13
			});

		},

		mapInitialized(mapIn) {
			this.initedMap = mapIn;
		},
		mapLoaded(mapIn) {
			//The god damn obj accepted by the flyTo fucker is some geoJson cock,
			//So I have a geo json obj somewhere as a const, deep copy the fucker
			//and then use the god damn thing instead of dealing with this bullshit format
			//            var geoObj = JSON.parse(JSON.stringify(GEO_JSON_DRAW_OBJ));
			//           geoObj.source.data.geometry.coordinates[0] = this.certificate.AreaGPSCoordinates;
			//          mapIn.addLayer(geoObj);
			//var geoObj2 = JSON.parse(JSON.stringify(GEO_JSON_DRAW_OBJ))
			//geoObj2.id = "newId"
			//geoObj2.source.data.geometry.coordinates[0] = this.mapGPSCoors2
			//mapIn.addLayer(geoObj2);
			//        mapIn.flyTo({
			//           center: polylabel(geoObj.source.data.geometry.coordinates),
			//          zoom: 13
			//      });
			//      this.calculateAreaInM2(geoObj.source.data.geometry);
		},
		//Attaches the geocoder and the draw controls in to our map
		calculateAreaInM2(mapGPSDetailsIn) {
			//Get turf to calculate the area in m2 using the gps coordinates we gave it
			this.areaInM2 = parseFloat(TurfArea(mapGPSDetailsIn));

			//If there is no area to be calculated
			if (this.areaInM2 < 1) {
				this.areaInM2 = "";
			}

			this.calculateWithUnits(this.areaInM2, this.areaUnit);
		}
	},
	components: { Mapbox }
};
</script>

<style>
.mapboxgl-canvas {
	position: inherit !important;
}
#viewLandRecordViewBox {
	padding-right: 3%;
	padding-left: 3%;
	padding-top: 20px;
	min-height: calc(100vh - 172px);
}
#viewLandRecordViewBox #map {
	height: 700px;
	border-radius: 10px;
}
#viewLandRecordViewBox .info_producer_name {
	font-size: 30px;
	font-weight: 300;
	color: #3490dc;
	line-height: 2.5em;
	text-decoration: underline;
}
#viewLandRecordViewBox .certificate_info_box {
	flex: 0 0 auto;
	margin: 5px;
	width: 100%;
}
#viewLandRecordViewBox .icon_header {
	font-size: 20px;
	padding-right: 10px;
	padding-left: 10px;
}
#viewLandRecordViewBox .info_body {
	font-size: 15px;
	text-align: left;
}
#viewLandRecordViewBox table,
td,
tr,
th {
	border: none;
}
#viewLandRecordViewBox tr:last-child > td {
	border: none;
}
#viewLandRecordViewBox tr {
	border-bottom: 1px solid #e3e3e3;
}
</style>
